import { ItemLabelModel } from '../../../../../shared/components/dropdown/models/dropdown-props.model';
import { castTo } from '../../../../../shared/utils/cast-to';
import { FilterOption } from '../../components/statistics-filters/models/filter-config.model';
import { AllStatisticsModel } from '../../mocks/statistics-all-data.mock';
import { StatisticsModel } from '../../models/statistics.model';

// TODO: REVIEW MAPPING FUNCTION AFTER BE IS READY
export const mapToTableStatisticsData = (
  statistics: AllStatisticsModel
): StatisticsModel[] => {
  return statistics.data.map(item => {
    const row: Record<string, unknown> = { date: item.date };

    item.entries.forEach(entry => {
      row[entry.name] = entry.value;
    });

    return castTo<StatisticsModel>(row);
  });
};

export const mapStatisticsFilterOptionsToItemLabelModel = (
  x: FilterOption
): ItemLabelModel<string> => ({ id: x.value, label: x.label });
